import React from "react";
import { Blade, Button } from "rhombus-react";
import { useSelector } from "react-redux";
import SubmitQrCodeForm from "widgets/modals/qr-codes/SubmitQrCodeForm";
import { SUBMIT_QR_CODE_FORM } from "forms/list";
import { SUBMIT_QR_MODES } from "utils/constants";
import { isInvalid, isSubmitting } from "redux-form";
import ProgressContainer from "widgets/ProgressContainer";
import { useParams } from "react-router";
import useImageFallback from "hooks/useImageFallback";

import "./SubmitQrCodeModal.css";

function SubmitQrCodeModal(props) {
	const { designId, mode, previewImageUrl, onClose, onSuccess } = props;
	const { idQrCode } = useParams();
	const { imageSrc } = useImageFallback(previewImageUrl, "/images/qr-code-placeholder@3x.png");

	const modalTitle = `${mode === SUBMIT_QR_MODES.EDIT ? "Edit" : "Generate"} QR Code`;
	const isSubmittingForm = useSelector(isSubmitting(SUBMIT_QR_CODE_FORM));
	const isLoadingForm = useSelector(state => state.qrCodes.isLoadingQrCodeConfiguration);
	const qrCodeFormIsInvalid = useSelector(isInvalid(SUBMIT_QR_CODE_FORM));

	const renderContent = () => {
		return (
			<ProgressContainer isLoading={isLoadingForm || isSubmittingForm} className="qr-submit-form-progress-container">
				<div className="submit-qrcode-modal-content">
					<div className="qr-code-preview-container" data-testid={"qr-code-preview-container"}>
						<img
							data-testid="qr-code-preview-img"
							src={imageSrc}
							alt="QR Code Preview"
							className="qr-code-preview-img"
						/>
					</div>
					<SubmitQrCodeForm
						idQrCode={idQrCode}
						designId={designId}
						mode={mode}
						onSuccess={onSuccess}
						onClose={onClose}
					/>
				</div>
			</ProgressContainer>
		);
	};

	const renderFooter = () => {
		return (
			<React.Fragment>
				<Button theme="grey" className="cancel-button" onClick={onClose}>
					Cancel
				</Button>
				<Button
					className="submit-button"
					theme="green"
					form={SUBMIT_QR_CODE_FORM}
					type="submit"
					disabled={qrCodeFormIsInvalid || isSubmittingForm}
				>
					{modalTitle}
				</Button>
			</React.Fragment>
		);
	};

	return (
		<Blade
			type="blade"
			setAppTitle={false}
			className="submit-qrcode-blade"
			title={modalTitle}
			allowFullScreen={false}
			xClose
			bladeProps={{ verticallyCenter: true }}
			onClose={onClose}
			renderContent={renderContent}
			renderFooter={renderFooter}
		/>
	);
}

SubmitQrCodeModal.displayName = "SubmitQrCodeModal";

export default SubmitQrCodeModal;
